import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@/lib/axios";
import { videoProductionServiceEndpoint } from "@/config/endpoints";

export default function useServices() {
  const query = useQuery({
    queryKey: ["video-production", "services"],
    queryFn: async () => {
      const res = await axiosInstance.get(videoProductionServiceEndpoint);
      return res.data?.videoServices ?? res.data ?? [];
    },
  });

  const raw = Array.isArray(query.data) ? query.data : [];
  const data = raw
    .filter((s: any) => !s.name?.startsWith("[ARCHIVED]"))
    .map((s: any) => ({
      ...s,
      variants: (s.variants ?? []).filter(
        (v: any) => !v.name?.startsWith("[ARCHIVED]")
      ),
    }));
  const serviceSelects =
    data?.map((val: any) => ({
      value: String(val.id),
      name: val.name ?? val.title ?? "Unnamed",
    })) ?? [];

  return {
    services: data,
    serviceSelects,
    length: data.length,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
